import React from 'react';
import {Paper, Stack, Typography} from '@mui/material';
import Timestamp from '../../../components/Timestamp';
import TabLoading from './TabLoading';
import TabEmpty from './TabEmpty';
import {usePagination} from './usePagination';
import TabPagination from './TabPagination';

/**
 * Alerts tab — displays entity-related alerts.
 *
 * @param {Object} props
 * @param {Array} props.alerts
 * @param {boolean} props.loading
 */
const AlertsTab = ({alerts, loading}) => {
    const {page, setPage, pageItems, totalPages, hasPagination} = usePagination(alerts);

    if (loading) return <TabLoading/>;
    if (!alerts.length) return <TabEmpty message="No alerts for this entity."/>;

    return (
        <Stack>
        <Stack spacing={1.5}>
            {pageItems.map((a) => (
                <Paper key={a.id} variant="outlined" sx={{p: 2}}>
                    <Typography fontWeight={600}>{a.title || 'Alert'}</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {a.message || a.description || '—'}
                    </Typography>
                    {(a.createdAt || a.createAt || a.created_at) && (
                        <Timestamp
                            component={Typography}
                            variant="caption"
                            color="text.secondary"
                            value={a.createdAt || a.createAt || a.created_at}
                        />
                    )}
                </Paper>
            ))}
        </Stack>
        <TabPagination
            hasPagination={hasPagination}
            page={page}
            totalPages={totalPages}
            totalItems={alerts.length}
            onChange={setPage}
        />
        </Stack>
    );
};

export default AlertsTab;
